module.exports = __webpack_public_path__ + "static/professional-57705a0dd3ca393a974d499a738577de.svg";